import dayjs from 'dayjs'
import * as yup from 'yup'

export const accountsFlagValidation: yup.SchemaOf<any> = yup
  .object({
    Flag: yup.string().required(),
  })
  .required()
